import { useTranslation as useI18nTranslation } from 'react-i18next'
import { useLanguageStore } from '../store/useLanguageStore'
import { SupportedLanguage } from '../i18n'

export const useTranslation = () => {
  const { t, i18n } = useI18nTranslation()
  const { currentLanguage, isLoading, changeLanguage } = useLanguageStore()

  const changeLanguageHandler = async (language: SupportedLanguage) => {
    await changeLanguage(language)
  }

  return {
    t,
    language: currentLanguage,
    isLoading,
    changeLanguage: changeLanguageHandler,
    isReady: i18n.isInitialized,
  }
}

export default useTranslation